import O1HD, { modules } from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { UIKind } from "../../../define/UIKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class startPage extends cc.Component {

    @property({type:cc.Node,displayName:"点击继续文本节点"})
    clickLbNode:cc.Node = null;

    @property({type:cc.Node,displayName:"第一个漫画节点"})
    one:cc.Node = null;

    @property({type:cc.Node,displayName:"第一个漫画节点"})
    two:cc.Node = null;

    @property({type:cc.Node,displayName:"第一个漫画节点"})
    three:cc.Node = null;
    @property({type:cc.Node,displayName:"开始前的最后页面"})
    endNode : cc.Node = null;

    oneInitX:number = 0;
    twoInitX:number = 0;
    threeInitX:number = 0;


    private _currStepCount : number = 1;

    start(){
        NormalGameManager._instance.resumeTimer();
        O1HD.getManagers().soundMgr.playMusic("startGame");
        this.one.opacity = 0;
        this.two.opacity = 0;
        this.three.opacity = 0;

        this.oneInitX = this.one.x;
        this.twoInitX = this.two.x;
        this.threeInitX = this.three.x;

        this.one.x -=375;
        this.three.x -= 375;
        this.two.x += 375;
        this.clickLbNode.active = false;
        this.startAni();
        NormalGameManager._instance.pauseTimer();

        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.START_PAGE);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.START_PAGE);
    }

    startAni(){
        // this.one.opacity = 100;
        let intervalTime:number = 1;
        let needTime:number = 0.5;
        cc.tween(this.one).to(needTime,{x:this.oneInitX,opacity:255}).start();
        this.clickLbNode.active = true;
        // this.scheduleOnce(()=>{
        //     this.clickLbNode.active = true;
        //     this.canClick = true;
        // },intervalTime * 2 + needTime);
    }

    canClick = true;

    async onClickNode(){
        if(!this.canClick){
            return;
        }
        this.canClick = false;
        if ( this._currStepCount == 4 ){
            // let weChatLink = "0";
            // let link = getOneWeChatTriggerTimeLinkById(weChatLink);
            // let isTrue:boolean = NormalGameManager._instance.addOneWeChatTriggerLink(weChatLink);
            // if(!isTrue){
            //     O1HD.getManagers().soundMgr.playMusic("hallBgm");
            //     this.node.destroy();
            //     this.node.removeFromParent();
            //     return;
            // }
            // let chitChat = getOneChitAryById(link.link[0].id);

            // // this.gameLayer.onBtnOpenPrefab(null,"weChat");
            // let people = NormalGameManager._instance.weChatManager.getOnePeopleById(chitChat.people);
            // let chatFramePrefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.WeChatGameBundle,"weChat/prefab/WeChatFrame");
            // let chitChatQueue = people.peopleChatLinkQueue;
            // let chatFrame = cc.instantiate(chatFramePrefab);
            // let cs = chatFrame.getComponent(WeChatFrame);
            // let isStart:boolean = weChatLink == startLinkId;
            // if(isStart){
            //     NormalGameManager._instance.driftBattleManager.registerStartEvent();
            //     O1HD.getServices().userSrv.setCoins(6000,true);
            // }
            // if(chitChatQueue.length >0){
            //     let chitChat = getOneChitAryById(chitChatQueue[0]);
            //     let fun = ()=>{
            //         NormalGameManager._instance.resumeTimer();
            //     }
            //     cs.bindData(chitChat,[],people,fun,isStart);
            // }
            // O1HD.Canvas().addChild(chatFrame);
            // O1HD.getManagers().soundMgr.playMusic("hallBgm");

            this.openStartEvent();

            this.node.destroy();
            this.node.removeFromParent();
        }else{
            let needTime:number = 0.5;
            switch ( this._currStepCount ) {
                case 1:
                    cc.tween(this.two).call(()=>{
                        // this.two.opacity = 100;
                        this.canClick = true;
                    }).to(needTime,{x:this.twoInitX,opacity:255}).start();
                    break;
                case 2:
                    cc.tween(this.three).call(()=>{
                        // this.three.opacity = 100;
                        this.canClick = true;
                    }).to(needTime,{x:this.threeInitX,opacity:255}).start();
                    break;
                case 3:
                    this.endNode.active = true;
                    this.endNode.getChildByName("lbDesc").opacity = 0;
                    cc.tween( this.endNode.getChildByName("lbDesc") )
                        .to( 1 , { opacity : 255 })
                        .call(()=>{
                            this.canClick = true;
                        })
                        .start();

            }
        }
        this._currStepCount ++;

    }

    openStartEvent() {
        let filePath = 'prefab/page/OpeningMailLayer';
        utilsView.openPopupLayer(
            filePath
            , O1HD.getManagers().gameMgr.getCurrMode().name as any
        );
    }

}
